import type { AnimationEvent, ReactNode } from "react";
import { useEffect, useRef, useState } from "react";

import { StyledExpandedContainer } from "./styles";

type ExpandedFiltersOverlayShellProps = {
    children: ReactNode;
    isOpen: boolean;
    skipEntryAnimation?: boolean;
    transformOrigin?: string;
    onAnimationEnd: (event: AnimationEvent<HTMLElement>) => void;
};

export const ExpandedFiltersOverlay = ({
    children,
    isOpen,
    skipEntryAnimation,
    transformOrigin,
    onAnimationEnd,
}: ExpandedFiltersOverlayShellProps) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [wasOpen, setWasOpen] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setWasOpen(true);
        }
    }, [isOpen]);

    const isClosing = !isOpen && wasOpen;
    const isAnimated = isOpen ? !skipEntryAnimation : isClosing;

    useEffect(() => {
        if (isOpen) {
            // preventScroll avoids a synchronous scroll-position layout on the freshly-mounted overlay subtree
            containerRef.current?.focus({ preventScroll: true });
        }
    }, [isOpen]);

    return (
        <StyledExpandedContainer
            data-automation="expanded-filters.overlay"
            ref={containerRef}
            tabIndex={-1}
            $isOpen={isOpen}
            $isAnimated={isAnimated}
            $transformOrigin={transformOrigin}
            onAnimationEnd={onAnimationEnd}
        >
            {children}
        </StyledExpandedContainer>
    );
};
